<script>
import AppDisplay from '@/components/AppDisplay.vue'
import { opcoesBioinsumo } from '@/libs/constants/praticas/opcoesSelects'

export default {
  components: {
    AppDisplay
  },
  props: {
    bioinsumo: {
      type: Object
    }
  },
  methods: {
    formataBioinsumos (values) {
      if (!values || !values.length) return ''
      const opcoesFormatadas = values.filter(v => v.tipo !== 'OUTROS').map(value => opcoesBioinsumo.find(opcao => opcao.id === value.tipo).nome)
      return opcoesFormatadas.join(', ')
    },
    verificaBiofertilizantes (values) {
      if (!values || !values.length) return false
      return values.find(v => v.tipo === 'BIOFERTILIZANTES')
    },
    verificaOutros (values) {
      if (!values || !values.length) return false
      return values.find(v => v.tipo === 'OUTROS')
    },
    getBiofertilizantes (values) {
      if (!values || !values.length) return ''
      return values.find(v => v.tipo === 'BIOFERTILIZANTES')?.especificacao
    },
    getOutros (values) {
      if (!values || !values.length) return ''
      return values.find(v => v.tipo === 'OUTROS')?.especificacao
    }
  }
}
</script>

<template>
  <div>
    <div class="mt-2">
      <span class="title-praticas">Dados dos bioinsumos</span>
      <hr />
    </div>
    <el-row v-if="!bioinsumo.utilizaBioinsumos">
      <el-col :span="12">
        <app-display label="Utiliza bioinsumo?" content="Não" />
      </el-col>
    </el-row>
    <el-row v-else>
      <el-col :span="12">
        <app-display label="Utiliza bioinsumo?" content="Sim" />
        <app-display label="Tipo(s) de bioinsumos aplicados:" :content="formataBioinsumos(bioinsumo.bioinsumos)" />
      </el-col>
      <el-col :span="12">
        <app-display v-if="verificaBiofertilizantes(bioinsumo.bioinsumos)" label="Biofertilizantes:" :content="getBiofertilizantes(bioinsumo.bioinsumos)" />
        <app-display v-if="verificaOutros(bioinsumo.bioinsumos)" label="Outros tipos de bioinsumos:" :content="getOutros(bioinsumo.bioinsumos)" />
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
  @import '../style.scss'
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Modals/VisualizacaoCadastro/Cadastro/Praticas/components/Bioinsumos.vue